import { Component, input } from '@angular/core';
import { TableName } from '@/common/enums/TableName';

@Component({
	selector: 'app-reservation-task-and-notes',
	templateUrl: './reservation-task-and-notes.component.html',
	styleUrls: ['./reservation-task-and-notes.component.scss'],
})
export class ReservationTaskAndNotesComponent {
	readonly resourceID = input<number>(null);
	protected readonly TableName = TableName;
}
